import { useState } from "react";
import { FileText, Folder, FolderOpen } from "lucide-react";

type FileNode = {
  name: string;
  type: "file" | "folder";
  children?: FileNode[];
};

export default function FileTree() {
  const fileStructure: FileNode[] = [
    {
      name: "src",
      type: "folder",
      children: [
        {
          name: "app",
          type: "folder",
          children: [
            {
              name: "pages",
              type: "folder",
              children: [
                { name: "home", type: "file" },
                { name: "portfolio", type: "file" },
                { name: "404", type: "file" },
                { name: "coming-soon", type: "file" },
              ],
            },
          ],
        },
        {
          name: "components",
          type: "folder",
          children: [
            {
              name: "icons",
              type: "folder",
              children: [{ name: "index.ts", type: "file" }],
            },
          ],
        },
        {
          name: "assets",
          type: "folder",
          children: [
            { name: "background", type: "file" },
            { name: "metrics", type: "file" },
            { name: "dots", type: "file" },
            { name: "map", type: "file" },
          ],
        },
      ],
    },
  ];

  return (
    <div className="text-sm font-mono text-ink-muted dark:text-white py-4 rounded-xl w-fit">
      {fileStructure.map((node, index) => (
        <TreeNode node={node} key={index} />
      ))}
    </div>
  );
}

function TreeNode({ node }: { node: FileNode }) {
  const [open, setOpen] = useState(true);
  const isFolder = node.type === "folder";

  return (
    <div className="pl-4">
      <div
        className="flex items-center gap-2 cursor-pointer hover:text-brand dark:hover:text-blue-400"
        onClick={() => isFolder && setOpen(!open)}
      >
        {isFolder ? (
          open ? (
            <FolderOpen size={16} />
          ) : (
            <Folder size={16} />
          )
        ) : (
          <FileText size={14} />
        )}
        <span>{node.name}</span>
      </div>

      {isFolder && open && node.children && (
        <div className="ml-2 border-l border-line dark:border-zinc-700 pl-2">
          {node.children.map((child, index) => (
            <TreeNode node={child} key={index} />
          ))}
        </div>
      )}
    </div>
  );
}
